import type { Client } from './entities/Client.js';
import type { ClientFeatureKey } from './entities/client-features.js';

/**
 * Whether a given workflow feature is active for a client. Two layers:
 *  1. `Client.enabled === false` is the master killswitch — turns everything off.
 *  2. Otherwise a feature is ON only when its key is listed in `Client.enabledFeatures`
 *     (opt-in — replaces the old global `*_ENABLED` env flags).
 *
 * Pure and isomorphic so it can be used in server workers/crons and in the client UI.
 */
export function isClientFeatureEnabled(
  client: Pick<Client, 'enabled' | 'enabledFeatures'>,
  feature: ClientFeatureKey,
): boolean {
  if (client.enabled === false) return false;
  return (client.enabledFeatures ?? []).includes(feature);
}
